import { getDestinations } from '@gonfalon/openapi/operations/getDestinations';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getDestinationsQuery = createQueryOptions(getDestinations);
